import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M20.4551 17.5439L23.6797 19L20.4551 20.4551L19 23.6797L17.5439 20.4551L14.3203 19L17.5439 17.5439L19 14.3203L20.4551 17.5439Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M14.1211 14.707C13.1127 15.8522 12.5 17.3542 12.5 19C12.5 20.0823 12.7655 21.1024 13.2334 22H2V16.5859L9 9.58594L14.1211 14.707Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M4 13.75H2V11.5H4V13.75Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22 13.75H20V11.5H22V13.75Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M15.25 5.75C16.9069 5.75 18.25 7.09315 18.25 8.75C18.25 10.4069 16.9069 11.75 15.25 11.75C13.5931 11.75 12.25 10.4069 12.25 8.75C12.25 7.09315 13.5931 5.75 15.25 5.75ZM15.25 7.75C14.6977 7.75 14.25 8.19772 14.25 8.75C14.25 9.30228 14.6977 9.75 15.25 9.75C15.8023 9.75 16.25 9.30228 16.25 8.75C16.25 8.19772 15.8023 7.75 15.25 7.75Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M4 9.75H2V6.5H4V9.75Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22 9.75H20V6.5H22V9.75Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M4.75 4H4V4.75H2V2H4.75V4Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M22 4.75H20V4H19.25V2H22V4.75Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M10.75 4H7.25V2H10.75V4Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M16.75 4H13.25V2H16.75V4Z"}}]};

const AiImage1Filled = Vue.extend<IconProps>({
  name: 'AiImage1FilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'ai-image-1-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default AiImage1Filled;
